import { AbstractMesh } from "@babylonjs/core/Meshes/abstractMesh";
import { isNotNullOrEmpty } from "../../utils/string";
import { NodeUserData } from "./NodeUserData";
export class LayerManager {
    constructor(pApp) {
        this.mApp = pApp;
        this.mLayers = new Map();
    }
    clear() {
        this.mLayers.clear();
    }
    isLayerVisible(pLayer) {
        if (pLayer == null)
            return (true);
        const tVisible = this.mLayers.get(pLayer);
        if (tVisible !== undefined)
            return (tVisible);
        else
            return (true); //layers are visible by default
    }
    setLayerVisible(pLayer, pVisible) {
        if (this.isLayerVisible(pLayer) === pVisible)
            return;
        this.mLayers.set(pLayer, pVisible);
        for (const tElement of this.mApp.model.elements)
            this.applyLayerVisibility(pLayer, pVisible, tElement.node);
    }
    getMeshLayer(pMesh) {
        return (NodeUserData.GetData(pMesh, LayerManager.NODEDATA_LAYER));
    }
    setMeshLayer(pMesh, pLayer) {
        NodeUserData.SetData(pMesh, LayerManager.NODEDATA_LAYER, pLayer);
        if (isNotNullOrEmpty(pLayer)) {
            if (!this.mLayers.has(pLayer))
                this.mLayers.set(pLayer, true); //add layer to map if it is a new layer
            pMesh.isVisible = this.isLayerVisible(pLayer);
        }
    }
    /**
     * Returns a list of meshes which belong to the given layer.
     * If a parent node is given only the parent node and its children will be considered,
     * otherwise all SceneElements currently added to the ModelManager will be iterated.
     */
    getMeshesOnLayer(pLayer, pParent) {
        const tMeshes = new Array();
        if (pParent !== undefined) {
            this.collectMeshesOnLayer(pLayer, pParent, tMeshes);
        }
        else {
            for (const tElement of this.mApp.model.elements) {
                this.collectMeshesOnLayer(pLayer, tElement.node, tMeshes);
            }
        }
        return (tMeshes);
    }
    //// internal //////////////////////////////////////////////////////////////////////////////////
    /** @internal */
    _getLayers() {
        return (this.mLayers);
    }
    applyLayerVisibility(pLayer, pVisible, pNode) {
        if (pNode == null)
            return;
        if (pNode instanceof AbstractMesh) {
            const tLayer = this.getMeshLayer(pNode);
            if (tLayer != null && tLayer === pLayer)
                pNode.isVisible = pVisible;
        }
        const tChilds = pNode.getChildTransformNodes(true);
        for (const tChild of tChilds) {
            this.applyLayerVisibility(pLayer, pVisible, tChild);
        }
    }
    collectMeshesOnLayer(pLayer, pNode, pMeshes) {
        if (pNode == null)
            return;
        if (pNode instanceof AbstractMesh) {
            const tLayer = this.getMeshLayer(pNode);
            if (tLayer != null && tLayer === pLayer)
                pMeshes.push(pNode);
        }
        const tChilds = pNode.getChildTransformNodes(true);
        for (const tChild of tChilds) {
            this.collectMeshesOnLayer(pLayer, tChild, pMeshes);
        }
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////////
LayerManager.NODEDATA_LAYER = "core:layer";
